export const root = "r1rl96j2";
export const profile = "pwzf9a1";
export const info = "i1a9kuz";
export const avatar = "a10m0ooy";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");